/**
 * Concordium Network Configuration for AppKit
 * Defines the Concordium mainnet network for use with AppKit
 * Similar to Polkadot network configuration pattern
 */

import { defineChain } from "@reown/appkit/networks";
import { CCD_CHAIN_ID, CCD_NAMESPACE, CCD_CHAIN_NAME, CCD_RPC_URL, CCD_BLOCK_EXPLORER_URL } from "./ccdConstants.js";
import concordiumIcon from "@/assets/img/Concordium_black_symbol.png";

/**
 * Concordium mainnet network configuration
 * Format compatible with AppKit networks
 * Following the pattern: ReownAppKitModalNetworkInfo with chainIcon
 */
export const concordium = defineChain({
  id: String(CCD_CHAIN_ID),
  name: CCD_CHAIN_NAME,
  chainNamespace: CCD_NAMESPACE,
  caipNetworkId: `${CCD_NAMESPACE}:${CCD_CHAIN_ID}`,
  chainId: CCD_CHAIN_ID,
  // Icon properties - both icon and chainIcon for compatibility
  icon: concordiumIcon,
  chainIcon: concordiumIcon,
  nativeCurrency: {
    name: "CCD",
    symbol: "CCD",
    decimals: 6,
  },
  currency: "CCD", // Similar to Polkadot example
  rpcUrl: CCD_RPC_URL, // Direct RPC URL (similar to Polkadot example)
  rpcUrls: {
    default: {
      http: [CCD_RPC_URL],
    },
    public: {
      http: [CCD_RPC_URL],
    },
  },
  explorerUrl: CCD_BLOCK_EXPLORER_URL, // Direct explorer URL (similar to Polkadot example)
  blockExplorers: {
    default: {
      name: "CCDScan",
      url: CCD_BLOCK_EXPLORER_URL,
    },
  },
});

